import axios from "axios";

import { toast } from "sonner";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

let tokenGetter = null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };
api.interceptors.request.use(async (config) => {
  const token = tokenGetter && (await tokenGetter());
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(undefined, (err) => {
  toast.error(err.response?.data?.detail?.toString() || "Erro de ligação ao servidor");
  return Promise.reject(err);
});

// Older matches lack half2_reset: infer it from 2nd half events (a reset clock has 2nd half events below 45:00)
const normalize = (m) => {
  if (m.half2_reset != null) return m;
  const p2 = m.events.filter((e) => e.period === 2);
  return p2.length ? { ...m, half2_reset: Math.min(...p2.map((e) => e.seconds)) < 2700 } : m;
};

export const getMatches = () => api.get("/matches").then((r) => r.data.map(normalize));
export const getMatch = (id) => api.get(`/matches/${id}`).then((r) => normalize(r.data));
export const createMatch = (data) => api.post("/matches", data).then((r) => r.data);
export const updateMatch = (id, data) => api.put(`/matches/${id}`, data).then((r) => normalize(r.data));
export const deleteMatch = (id) => api.delete(`/matches/${id}`);
export const addEvent = (id, data) => api.post(`/matches/${id}/events`, data).then((r) => r.data);
export const deleteEvent = (id, eid) => api.delete(`/matches/${id}/events/${eid}`);
export const updateEvent = (id, eid, data) => api.patch(`/matches/${id}/events/${eid}`, data).then((r) => r.data);
export const getMe = () => api.get("/me").then((r) => r.data);
export const getUsers = () => api.get("/users").then((r) => r.data);
export const setUserRole = (uid, role) => api.patch(`/users/${uid}/role`, { role }).then((r) => r.data);
